<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4>
          <strong>{{ $store.state.form.judulInsentif }}</strong>
        </h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.namaInsentif" label-cols-md="3">
            <b-form-select :options="tunTetap" v-model="dataTTT.masterTunjanganTidakTetapId" @input="setNominal(dataTTT.masterTunjanganTidakTetapId)"></b-form-select>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.nominalInsentif" label-cols-md="3">
            <b-form-input type="number" v-model="dataTTT.nominalTunjangan" :placeholder="convert(dataTTT.nominalTunjangan)"></b-form-input>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.maksimalInsentif" label-cols-md="3">
            <b-form-input type="number" v-model="dataTTT.maksimalTunjangan" :placeholder="convert(dataTTT.maksimalTunjangan)"></b-form-input>
          </b-form-group>
        </b-form>

        <b-button variant="primary" @click="simpan()"> <CIcon name="cil-plus" /> {{ $store.state.form.tambahData }} </b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-tunjtdktetap @click="dataPeringatan = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-delete :dataTunjanganTetap="dataTunjanganTetap" @alert="triggerAlert($event), getDatas()" />
  </div>
</template>

<script>
// import modalInput from "../../../component/hcms/karyawan/tunjanganTetap/modalInput.vue";
// import modalEdit from "../../../component/hcms/karyawan/tunjanganTetap/modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  components: {
    // modalInput,
    // modalEdit,
    modalDelete,
  },
  props: ["data", "activeTab"],
  data() {
    return {
      items: [],
      dataTunjanganTetap: "",
      dataTTT: {
        masterTunjanganTidakTetapId: "",
        nominalTunjangan: "",
        maksimalTunjangan: "",
      },
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          class: "table-number text-center",
        },
        {
          key: "namaTunjangan",
          label: "Tunjangan Tetap",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaNominalTunjangan",
          label: "Nominal Insentif (perHari)",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaMaksimalTunjangan",
          label: "Maksimal Insentif",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-3 text-center",
        },
      ],
      tunTetap: [],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDatas();
      }
    },
    activeTab(newVar) {
      if (newVar == 3) {
        this.getDatas();
      }
    },
  },
  methods: {
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    setNominal(x) {
      this.tunTetap.forEach((item) => {
        if (item.masterTunjanganTidakTetapId == x) {
          this.dataTTT.nominalTunjangan = item.nominalTunjangan;
          this.dataTTT.maksimalTunjangan = item.maksimalTunjangan;
        }
      });
    },
    async getDatas() {
      let vm = this;
      let tunTetap = await vm.$axios.post("masterTunjanganTidakTetap/list");

      vm.tunTetap = tunTetap.data.data.map((item) => {
        return { ...item, value: item.masterTunjanganTidakTetapId, text: item.namaTunjangan };
      });

      let tunKaryawan = await vm.$axios.get("poolTunjanganTidakTetap/detailsTunjanganTidakTetapByKaryawanId/" + vm.data.dataKaryawanId);
      // console.log('tunKaryawan', tunKaryawan);
      vm.items =
        tunKaryawan.data.status == 200
          ? tunKaryawan.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                namaNominalTunjangan: vm.convert(x.nominalTunjangan),
                namaMaksimalTunjangan: vm.convert(x.maksimalTunjangan),
              };
            })
          : [];
    },
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.dataTTT.dataKaryawanId = vm.data.dataKaryawanId;
      vm.$axios
        .post("poolTunjanganTidakTetap/register", vm.dataTTT)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN INSENTIF",
              showing: true,
            });
            // vm.variant = "success";
            // vm.msg = "BERHASIL MENDAFTARKAN INSENTIF";
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
            this.dataTTT = {
              masterTunjanganTidakTetapId: "",
              nominalTunjangan: "",
            };
            this.getDatas();
            vm.$emit("change");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            // vm.variant = "danger";
            // vm.msg = _.toUpper(res.data.message);
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          // vm.variant = "danger";
          // vm.msg = "TERJADI KESALAHAN PADA SERVER";
          // vm.showing = true;
          // setTimeout(() => {
          //   vm.showing = false;
          // }, 4000);
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("change");
    },
  },
};
</script>
